export default __webpack_public_path__ + "static/media/shield2.2a457ebc.svg";